<template>
  <v-dialog :value="display" :persistent="persistent" :max-width="maxWidth">
    <v-card>
      <v-card-title>
        <slot name="title"> </slot>
      </v-card-title>
      <v-card-text>
        <slot name="body"></slot>
      </v-card-text>
      <v-card-actions>
        <v-btn color="success" :loading="okLoading" @click="$emit('ok')">
          <v-icon left x-small>
            fas fa-check
          </v-icon>
          Ok
        </v-btn>
        <v-btn color="error" @click="$emit('cancel')">
          <v-icon left x-small>
            fas fa-times
          </v-icon>
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    okLoading: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    maxWidth: {
      type: Number,
      default: () => {
        return 600
      }
    },
    persistent: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    display: {
      type: Boolean,
      default: () => {
        return true
      }
    }
  }
}
</script>
